import React, { RefObject, useState } from "react";
import { AuthData } from "../types/AuthData";
import Icon from "../components/Icon";
import icon1 from "../assets/musical-notes.png";
import icon2 from "../assets/map.png";
import icon3 from "../assets/gallery.png";
import { Page } from "../types/Page";
import { Slider } from "../components/Slider";

interface props {
  data: AuthData;
  volumeUpdater: number;
}

const WebClient: React.FC<props> = ({ data, volumeUpdater }) => {
  const [page, setPage] = useState<Page>(Page.AUDIO);

  const getScaleClass = (current: Page) =>
    page === current ? "scale-100" : "scale-75";

  return (
    <div className="w-full h-full relative bg-black overflow-hidden">
      <div className="absolute inset-0 bg-[url(./assets/bg.png)] bg-center bg-cover opacity-70" />
      <div className="flex justify-center items-center h-full w-full relative z-10">
        <div
          className="flex justify-between
            min-w-[800px] min-h-[500px] max-w-[1200px] max-h-[800px]
            w-3/4
            h-3/4
            rounded-2xl
            border border-white/20
            bg-white/10
            backdrop-blur-xl
            shadow-2xl
          "
        >
          <div className="flex flex-[1]">
            <div className="ml-5 gap-10 flex flex-col justify-center select-none">
              <div
                onClick={() => setPage(Page.AUDIO)}
                className={`cursor-pointer transition-transform ${getScaleClass(Page.AUDIO)}`}
              >
                <Icon url={icon1} />
              </div>

              <div
                onClick={() => setPage(Page.LIVEMAP)}
                className={`cursor-pointer transition-transform ${getScaleClass(Page.LIVEMAP)}`}
              >
                <Icon url={icon2} />
              </div>

              <div
                onClick={() => setPage(Page.ONRIDEPHOTO)}
                className={`cursor-pointer transition-transform ${getScaleClass(Page.ONRIDEPHOTO)}`}
              >
                <Icon url={icon3} />
              </div>
            </div>
          </div>
          <div className="flex flex-[7] justify-center items-center flex-col gap-5">
            <div className="flex justify-center items-center gap-5">
              <img
                className="h-[25px]"
                src={"/ranks/" + data.rank + ".png"}
                alt={data.rank}
              ></img>
              <p className="text-white text-2xl font-['Minecraft'] font-light flex items-center justify-center text-center">
                {data.name}
              </p>
            </div>
            <img
              src={"https://mc-heads.net/avatar/" + data.uuid + "/150"}
              width={150}
              height={150}
              className="rounded-lg"
            ></img>
            <div className="w-full select-none">
              <div className="flex flex-col justify-center items-center gap-5">
                <label className="text-xl text-white">Ambient:</label>
                <Slider type="music" volumeUpdater={volumeUpdater}></Slider>
              </div>
              <div className="flex flex-col justify-center items-center gap-5">
                <label className="text-xl text-white">Effects:</label>
                <Slider type="effect" volumeUpdater={volumeUpdater}></Slider>
              </div>
            </div>
          </div>
          <div className="flex flex-[1]"></div>
        </div>
      </div>
    </div>
  );
};

export default WebClient;
